import { useContext } from "react";
import ThemeContext from "./context/themeContext";

const useCustomStyles = (configObj = {}) => {
  const { dark } = useContext(ThemeContext);

  // Initialize styles with default values
  let styles = {
    border: "none",
    background: "transparent",
  };

  // Helper to validate and set style properties
  const validateAndSetStyle = (key, value) => {
    if (value && typeof value === "string") {
      // Check if value exists and is a string
      styles[key] = value;
    } else if (value) {
      // If value exists but is not a string, throw an error
      throw new Error(`${key} value must be a string.`);
    }
  };

  // Safely access and process optional keys in configObj
  validateAndSetStyle("background", configObj.background);
  validateAndSetStyle("border", configObj.border);

  // Apply dark background if applicable and present
  if (dark && configObj.darkBG) {
    validateAndSetStyle("background", configObj.darkBG);
  }

  return {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      transform: "translate(-50%, -50%)",
      maxHeight: "80%",
      padding: "1rem",
      wordBreak: "break-all",
      ...styles,
    },
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: dark ? "rgba(34, 34, 34, 0.75)" : "rgba(0, 0, 0, 0.75)", // Dark or light overlay
      zIndex: 1000,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  };
};

export default useCustomStyles;
